import React from 'react';

// Components
import ModalField from 'components/modal/field/ModalField';
import ModalHint from 'components/modal/hint/ModalHint';
import ModalLabel from 'components/modal/label/ModalLabel';
import RichSelect from 'components/richselect/RichSelect';

/**
 * FieldTypeField
 *
 * Renders the field type selector.
 *
 * @param {string} draftType - Currently selected field type.
 * @param {array} mergedTypeOptions - Available field type options.
 * @param {function} onTypeChange - Handler for changing the field type.
 * @param {boolean} disabled - Whether the field type selector is disabled.
 * @param {string} error - Error message for the field type selector.
 *
 * @returns {ReactNode} The rendered component.
 */
const FieldTypeField = ({
    draftType,
    mergedTypeOptions,
    onTypeChange,
    disabled,
    error,
}) => (

    <ModalField>

        <ModalLabel label="Field Type" />
        <ModalHint hint="The type of field you want to create." />

        <RichSelect
            value={draftType}
            onValueChange={(value) => onTypeChange(value)}
            options={mergedTypeOptions}
            placeholder="Select a type"
            style={{ width: '100%' }}
            disabled={disabled}
            error={!!error}
            helperText={error}
        />

    </ModalField>

);

export default FieldTypeField;
